var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 372.87 410.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2081a5;\n      }\n\n      .cls-2 {\n        fill: #923e38;\n      }\n\n      .cls-3 {\n        fill: #6c9d6f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.09,86.8c15.06,19.77,53.56-8.24,74.85-23.56,25.22-18.15,47.89-40.21,31.64-54.88-21.18-19.12-44.15-1.65-69.26,14.7-21.97,14.31-56.47,38.48-37.22,63.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.99,184.77c24.85,0,24.16-33.71,23.12-59.91-1.23-31.05-8.1-30.57-27.38-30.56-17.87,0-24.23,18.21-24.22,38.23,0,26.22-.12,52.24,28.48,52.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.73,113.74c8.16,10.67,39.28.45,60.56-14.87,25.22-18.15,48.01-36.46,32.31-51.73-14.12-13.72-35.34-3.43-58.44,13.74-21.05,15.64-46.65,36.87-34.43,52.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.38,159.92c5.86,8.75,21.97-5.99,48.18-6.77,7.43-.22,28.88,30.15,46.01,32.34,3.95.51,8-1.69,11.22-4.74,3.79-3.59,8.91-7.39,7.26-12.45-4.55-13.89-29.55-32.36-34.85-37.52-14.12-13.72-35.95-21.85-57.2-9.14-18.21,10.89-28.14,27.06-20.62,38.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.01,146.46c4.44-25.79,38.69-.85,53.14-12.17,7.33-5.74-4.78-29.24-13.03-53.34-8.04-23.47-34.65-6.4-31.29-37.14,1.29-11.82,25.63-12.16,30.28-12.25,5.21-.11,22.12,10.84,29.54,22.48,11.82,18.55,22.82,70.07,22.81,77.46-.01,19.69,4.1,32.49-14.28,42.67-7.82,4.33-18.7.96-33.81-2.63-20.74-4.92-47.27-2.46-43.37-25.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.45,180.87c-11.72,17.51,14.44,29.72,38.92,39.12,29.01,11.14,60.04,13.81,60.04-12.58,0-16.97-21.56-6.78-48.59-16.68-24.62-9.02-39.17-26.58-50.37-9.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.05,49.05c-16.81,0-24.94,37.48-28.44,65.36-3.87,30.83,11.91,43.56,26.44,43.01,19.67-.74,21.86-27.89,21.5-56.66-.32-26.22,4.94-51.7-19.51-51.7h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.65,328.66c16.69-27.49,41.53,34.17,66.66,22.16,7.08-3.38-2.76-30.52-4.94-64.42-4.31-66.96,3.15-70.48-7.27-73.66-9.59-2.93-25.35,22.35-39.98,5.65-2.56-2.92-8.1-16.79-3.21-21.64,20.69-20.54,54.21-43.33,75.06-35.16,3.4,1.33,10.53,2.24,12.77,8.35,7.79,21.29,3.23,64.25,3.38,76.23.29,21.99,10.72,101.08,10.72,108.47-.01,19.69,1.59,36.88-16.79,47.05-7.82,4.33-23.08-1.11-40.8-6.54-30.19-9.24-66.01-49.35-55.6-66.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.34,392.73c10.95,13.49,36.14-.7,56.18-17.62,22.03-18.6,43.31-35.85,27.61-51.11-14.12-13.72-33.39,10.31-52.59,28.55-19,18.07-42.38,26.4-31.2,40.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.95,325.02c-9.95,16.58,6.03,24.9,36.08,30.48,17.51,3.25,42.62,6.07,48.94,3.01,9.24-4.47,20.21-7.63,21.8-17.85,1.45-9.28-42.13-3.94-57.53-9.75-25.24-9.52-40.11-21.2-49.3-5.89h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.93,403.66c5.22-20.89-13.88-18.33-27.39-17.95-31.06.86-34.77,11.68-32.35,17.67,3.73,9.26,2.27,7.88,31.03,6.72,22.4-.9,27.81-2.83,28.71-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.47,319.48c1.02-11.22-4.58-16.49-12.75-16.49-12.18,0-17.43,10.23-15.81,16.65,2.44,9.68,5.96,11.64,14.63,12.49,12.98,1.27,13.59-8.96,13.93-12.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.81,393.92c16.14-20.36,36.7-12.79,61.26-15.81,27.58-3.4,27.18-9.21,32.91-14.6,8.52-8.01,12.5-39.15,8.59-84.16-1.69-19.5,10.18-23.33,14.82-22.89,11.82,1.14,14.1,11.63,15.89,25.12,2.2,16.52,2.39,37.12,2.39,45.63,0,21.99-4.26,52.85-22.64,63.03-7.82,4.33-37.02,11.65-51.28,14.29-30.06,5.56-73.01,3.36-61.94-10.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.81,209.33c.75-20.36-32.86-12.16-46.29-10.76-39.85,4.16-47.67,4.42-45.67,17.83s7.19,10.48,30.57,10.75c1.81.02,7.17,4.97,8.16,16.63.22,2.58,1.29,7.09-1.3,9.34-4.62,4-32.81,1.64-32.58,16.37.3,19.55,24.43,9.5,37.1,17.7,6.28,4.07-4.33,44.97,21.73,42.9,22.01-1.75-2.46-38.84,11.79-46.21,10.16-5.26,32.07.22,34.59-15.59,3.28-20.57-39.65-11.86-45.94-20.2-3.45-4.58-2.88-20.07-.46-21.58,4.73-2.96,12.57-.2,17.86-2.23,7.12-2.74,10.33-11.09,10.47-14.94h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.87,79.46c10.11,13.27,44.57-11.23,58.86-21.51,16.93-12.19,39.19-32.6,28.27-42.46-14.22-12.84-36.68,4.5-53.53,15.48-14.75,9.61-46.52,31.53-33.6,48.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.47,169.55c18.2,0,12.99-13.67,12.23-32.86-.9-22.74.04-29.66-14.08-29.65-13.09,0-14.94,11.96-14.93,26.62,0,19.2-4.17,35.88,16.78,35.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.58,105.35c5.3,6.94,38.84-8.98,52.67-18.94,16.4-11.8,30.04-21.56,21.59-31-7.69-8.6-21.61-2.67-36.74,7.37-14.21,9.43-45.48,32.19-37.53,42.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.35,144.33c.47-5.2-2.12-7.65-5.91-7.65-5.65,0-8.08,4.74-7.33,7.72,1.13,4.49,2.76,5.4,6.78,5.79,6.02.59,6.3-4.15,6.46-5.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.68,134.56c.49-5.4-2.2-7.93-6.13-7.93-5.85,0-8.38,4.92-7.6,8.01,1.17,4.66,2.87,5.6,7.04,6.01,6.24.61,6.54-4.31,6.7-6.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.49,137.11c.51-5.59-2.28-8.22-6.35-8.22-6.07,0-8.68,5.1-7.88,8.3,1.21,4.83,2.97,5.8,7.29,6.23,6.47.63,6.77-4.46,6.94-6.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.18,150.28c.47-5.16-2.1-7.58-5.86-7.58-5.6,0-8.01,4.7-7.27,7.65,1.12,4.45,2.74,5.35,6.72,5.74,5.97.58,6.25-4.12,6.4-5.82h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.09,164.7c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.67,186.54c-7.93,12.02,16.28,19.93,33.01,26.35,19.83,7.61,46.28,14.87,46.28-3.16,0-8.76-20.59-3.77-39.05-10.54-16.82-6.16-34.43-21.45-40.24-12.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.36,146.75c-2.84,15.04,25.3,17.36,41.28,19.73,18.93,2.8,34.96-3.75,35.54-15.61.69-14.13-21.23-14.68-29.77-8.16-12.84,9.79-43.78-13.26-47.04,4.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.69,123.37c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.88,104.16c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.84,84.94c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.9,64.16c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.82,52.17c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.6,67.53c-10.58,0-12.58,25.33-14.78,42.87-2.43,19.4,4.38,25.66,13.52,25.31,12.38-.47,10.35-15.98,10.13-34.09-.2-16.5,6.51-34.1-8.88-34.1h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.68,191.98c-5.96,0-11.08,5.19-12.34,9.21-1.84,5.84-.1,32.51.49,44.42.75,15.26-.36,41.15,8.32,51.39,2.43,2.86,8.81,2.54,12.99,1.5,9.58-2.39,7.24-33.51,7.02-51.62-.2-16.5,2.75-54.91-16.47-54.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.57,177.13c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.46,184.78c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.52,197.67c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.58,208.65c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.1,203.93c-3.63,0-5.29,4.07-6.29,12.96-.42,3.71.28,25.13.63,32.4.46,9.3-1.28,24.92,4.01,31.15,1.48,1.75,5.37,1.55,7.92.92,5.84-1.45,4.42-20.43,4.28-31.47-.12-10.06,1.16-45.95-10.55-45.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.43,315.93c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M354.66,339.63c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M355.79,360.73c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.61,336.21c-9.31,12.15,12.26,28.13,24.55,38.6,14.57,12.41,50.83,22.52,58.24,19.3,4.59-1.99,6.64-11.18,2.16-15.24-11.58-10.47-25.37-12.37-37.41-17.28-33.69-13.76-39.03-36.5-47.55-25.38h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.5,385.42c7.09,8.74,28.85-3.93,41.83-14.89,14.27-12.04,31.56-25.85,21.39-35.73-9.14-8.89-25.14,9.3-37.57,21.12-12.31,11.7-32.89,20.58-25.65,29.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.14,318.53c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.94,398.82c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.57,398.82c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.4,400.98c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.63,393.76c9.2-11.6,13.69-9.61,27.68-11.34,15.71-1.94,32.59-15.19,34.17-53.79.46-11.15,5.78-25.34,15.02-7.89,3.97,7.5,1.46,26.02.93,30.88-1.36,12.46-5.99,27.55-16.47,33.35-4.46,2.47-18.98,9.07-27.11,10.57-17.13,3.17-40.54,6.18-34.23-1.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.26,386.06c8.07-.35,34.06-11.68,35.22-40.04.34-8.19,1.55-31.75,8.34-18.93,2.92,5.51-.37,28.21-.76,31.78-1,9.15-9.05,20.14-16.74,24.4-3.27,1.81-24.32,11.64-42.27,12.29-12.79.47-.51-8.77,16.22-9.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.97,393.71c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.06,394.09c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.69,299.61c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.66,278.59c.5-5.49-2.24-8.07-6.24-8.07-5.96,0-8.53,5.01-7.74,8.15,1.19,4.74,2.92,5.7,7.16,6.12,6.35.62,6.65-4.39,6.82-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.44,330.52c-5.96,9.93,3.61,14.92,21.61,18.25,8.22,1.52,28.1,7.61,36.49,3.36,2.32-1.17,1.09-9.09-.98-10.34-6.88-4.16-18.38-4.27-27.6-7.75-15.12-5.7-24.02-12.7-29.52-3.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.63,349.08c.3-3.27-1.33-4.81-3.72-4.81-3.55,0-5.08,2.98-4.61,4.85.71,2.82,1.74,3.39,4.26,3.64,3.78.37,3.96-2.61,4.06-3.69h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.42,346.42c.3-3.27-1.33-4.81-3.72-4.81-3.55,0-5.08,2.98-4.61,4.85.71,2.82,1.74,3.39,4.26,3.64,3.78.37,3.96-2.61,4.06-3.69h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.99,267.24c-.89,2.88-.46,9.05,3.27,10.35,9.69,3.37,30.58.9,42.19,0,19.07-1.48,34.19.41,41.6-6.35,2.9-2.65-1.33-9.27-4.43-10.25-8.68-2.73-25.12-3.62-35.4-3.23-16.12.62-45.37,3.5-47.23,9.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.17,211.76c-.76,2.92-.04,9.06,3.75,10.18,9.83,2.92,30.59-.51,42.15-1.95,18.98-2.36,23.42,2.23,30.5-4.87,2.78-2.78.75-10.98-2.26-12.19-5.41-2.18-16.66-1.23-26.92-.36-16.08,1.37-45.63,3.12-47.21,9.19h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.2,232.83c.3-3.27-1.33-4.81-3.72-4.81-3.55,0-5.08,2.98-4.61,4.85.71,2.82,1.74,3.39,4.26,3.64,3.78.37,3.96-2.61,4.06-3.69h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.19,246.48c.3-3.27-1.33-4.81-3.72-4.81-3.55,0-5.08,2.98-4.61,4.85.71,2.82,1.74,3.39,4.26,3.64,3.78.37,3.96-2.61,4.06-3.69h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.82,289.45c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.47,304.56c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.75,319.67c.36-3.92-1.6-5.76-4.45-5.76-4.25,0-6.09,3.57-5.52,5.82.85,3.38,2.08,4.07,5.11,4.36,4.53.44,4.75-3.13,4.86-4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.04,212.45c-.51,1.96-.73,5.8,1.81,6.55,6.6,1.96,26.99-.56,34.75-1.52,12.74-1.59,21.04,1.34,25.8-3.42,1.86-1.87.56-6.78-1.46-7.6-3.63-1.46-16.56-1.27-23.45-.68-10.8.92-36.39,2.6-37.45,6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.58,268.5c-.56,1.8-.97,5.43,1.36,6.24,6.05,2.11,29.13,0,36.38-.57,11.9-.93,27.77.49,32.4-3.73,1.81-1.65.36-5.47-1.57-6.08-5.42-1.7-23.3-2.82-29.72-2.57-10.07.39-37.68,2.97-38.85,6.71h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1eb6857e61a826dcc320406da4962ed2.svg";
export { ForwardRef as ReactComponent };